export const REPORT_TYPES = {
    OverallReport: "OverallReport",
    TrailersReport: "TrailersReport",
    MonthlyOverallReport: "MonthlyOverallReport",
    PlanFactReport: "PlanFactReport",
    DriversReport: "DriversReport",
    CitiesReport: "CitiesReport",
    LoadUnloadTimeReport: "LoadUnloadTimeReport",
    ExcessMileageReport: "ExcessMileageReport",
    EmptyMileageBidsPlanFactReport: "EmptyMileageBidsPlanFactReport",
    OverallReportWithVat: "OverallReportWithVat",
    CarsWithoutBidsReport: "CarsWithoutBidsReport",
    CarIdlesReport: "CarIdlesReport",
    BidPointDeviationReport: "BidPointDeviationReport",
    ResponsibleLogistsReport: "ResponsibleLogistsReport",
    DriverAppUsageReport: "DriverAppUsageReport",
    AverageTonnageReport: "AverageTonnageReport",
    BidsCreatedOnTimeReport: "BidsCreatedOnTimeReport",
    BidsWithRegionalFramesReport: "BidsWithRegionalFramesReport",
    BidPriceChangeReport: "BidPriceChangeReport",
    CounterpartiesReport: "CounterpartiesReport",
    DriverAppInstallReport: "DriverAppInstallReport",
    InterBidIntervalReport: "InterBidIntervalReport",
    DailyVehicleMileageReport: "DailyVehicleMileageReport",
    TripScenariosReport: "TripScenariosReport",
    MarginalityReport: "MarginalityReport",
    OrganizationActivityReport: "OrganizationActivityReport",
    RefuelingsReport: "RefuelingsReport",
    DriverWorkAndRestReport: "DriverWorkAndRestReport",
    DriversStatsOfYearReport: "DriversStatsOfYearReport",
    FuelLimitsReport: "FuelLimitsReport",
    DocumentAssignmentProgressReport: "DocumentAssignmentProgressReport",
    FuelCardsPaymentReport: "FuelCardsPaymentReport",
    PlanPointIntersectionsReport: "PlanPointIntersectionsReport",
    PlanFactRefuelingsReport: "PlanFactRefuelingsReport",
    RefuelingsVisitStatsReport: "RefuelingsVisitStatsReport",
    SuitableOrdersReport: "SuitableOrdersReport",
    EmptyMileageReport: "EmptyMileageReport",
    ClientStatisticsReport: "ClientStatisticsReport",
    PlanFactOverallReport: "PlanFactOverallReport",
    LogisticSalaryReport: "LogisticSalaryReport",
    AccountsReceivableReport: "AccountsReceivableReport",
    AccountsPayableReport: "AccountsPayableReport",
    IncomesAndExpensesReport: "IncomesAndExpensesReport",
};
